import { GoArrowRight, GoArrowDown } from "react-icons/go";

const DEFAULT_STEPS = [
  { number: "1", title: "Anket Doldurun", description: "Aşağıdakı formu doldurun" },
  { number: "2", title: "Seçim Testi", description: "Onlayn qabiliyyət testi" },
  { number: "3", title: "Müsahibə", description: "Komanda ilə görüş" },
  { number: "4", title: "Qəbul", description: "Proqrama başla!" },
];

function chunk(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) result.push(arr.slice(i, i + size));
  return result;
}

function ProcessCard({ step }) {
  return (
    <article className="w-[180px] xl:w-[210px] h-full min-h-[160px] rounded-[14px] border border-main-pink/50 bg-white px-[16px] py-[18px] xl:px-[22px] xl:py-[20px] flex flex-col items-center justify-center">
      <div className="inline-flex h-[36px] min-w-[36px] items-center justify-center rounded-full bg-main-pink px-[9px] text-[14px] font-[600] leading-none text-white">
        {step.number}
      </div>
      <h3 className="mt-[14px] text-[#0A0A0A] text-[14px] xl:text-[16px] font-[700] leading-[130%] text-center">{step.title}</h3>
      <p className="mt-[4px] text-[#6A7282] text-[12px] xl:text-[14px] font-[400] leading-[140%] text-center">{step.description}</p>
    </article>
  );
}

function StepGrid({ steps, cols }) {
  const rows = chunk(steps, cols);
  return (
    <div className="flex flex-col items-center">
      {rows.map((row, rowIndex) => (
        <div key={`row-${rowIndex}`}>
          <div className="flex items-stretch justify-center gap-[12px] xl:gap-[16px]">
            {row.map((step, index) => (
              <div key={`${step.number}-${rowIndex}-${index}`} className="flex items-stretch gap-[12px] xl:gap-[16px]">
                <ProcessCard step={step} />
                {index < row.length - 1 && (
                  <div className="flex items-center shrink-0">
                    <GoArrowRight className="text-main-pink text-[20px] xl:text-[24px]" />
                  </div>
                )}
              </div>
            ))}
          </div>
          {rowIndex < rows.length - 1 && (
            <div className="flex justify-center py-[14px]">
              <GoArrowDown className="text-main-pink text-[24px]" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default function SeoPageProcess({ seoPage }) {
  const section = seoPage?.application_section ?? seoPage?.process_section ?? {};
  const rawItems = section.items ?? section.steps ?? [];
  const steps = rawItems.length
    ? rawItems.map((item, i) => ({
        ...item,
        number: item.number ?? String(i + 1),
      }))
    : DEFAULT_STEPS;

  return (
    <section className="bg-[#F8FAFF] py-[80px]">
      <div className="max-w-[90%] mx-auto">
        <span className="inline-flex min-w-[140px] h-[28px] px-2 items-center justify-center rounded-full bg-[#DDECFF] text-[12px] font-[600] tracking-[0.08em] uppercase">
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884]">
            {section.label ?? section.badge ?? "QƏBUL PROSESİ"}
          </span>
        </span>

        <h2 className="mt-[16px] text-[#0A0A0A] text-[28px] md:text-[36px] font-[600] leading-[120%]">
          {section.title ?? "Necə müraciət etmək olar?"}
        </h2>

        {(section.description ?? section.subtitle) && (
          <p className="mt-[12px] text-[#6A7282] text-[16px] leading-[140%]">
            {section.description ?? section.subtitle}
          </p>
        )}

        {/* Mobile: 1 per row */}
        <div className="mt-[32px] md:hidden">
          <StepGrid steps={steps} cols={1} />
        </div>

        {/* Tablet: 2 per row */}
        <div className="mt-[28px] hidden md:block xl:hidden">
          <StepGrid steps={steps} cols={2} />
        </div>

        {/* Desktop: 4 per row */}
        <div className="mt-[28px] hidden xl:block">
          <StepGrid steps={steps} cols={4} />
        </div>
      </div>
    </section>
  );
}
